export default __webpack_public_path__ + "static/media/step-two-barrels.b65ae77e.jpg";